import React from "react";

export default function ListIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M7.83333 2.6665H14.5V3.99984H7.83333V2.6665ZM7.83333 5.33317H11.8333V6.6665H7.83333V5.33317ZM7.83333 9.33317H14.5V10.6665H7.83333V9.33317ZM7.83333 11.9998H11.8333V13.3332H7.83333V11.9998ZM2.5 2.6665H6.5V6.6665H2.5V2.6665ZM3.83333 3.99984V5.33317H5.16667V3.99984H3.83333ZM2.5 9.33317H6.5V13.3332H2.5V9.33317ZM3.83333 10.6665V11.9998H5.16667V10.6665H3.83333Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
